/** * 分页组件 */
<template>
	<el-pagination class="page-box" background :current-page="pageparm.currentPage"
		:page-sizes="[5, 10, 15, 20, 50, 100, 200, 500, 1000]" :page-size="pageparm.pageSize"
		layout="total, sizes, prev, pager, next, jumper" :total="childMsg.total" @size-change="handleSizeChange"
		@current-change="handleCurrentChange"></el-pagination>
</template>
<script>
export default {
	name: "Pagination",
	props: ["childMsg"],
	data() {
		return {
			pageparm: {
				currentPage: this.childMsg.currentPage || this.childMsg.pageIndex,
				pageSize: this.childMsg.pageSize
			}
		};
	},
	created() { },
	watch: {
		childMsg: {
			handler(newVal) {
				if (newVal) {
					this.pageparm.currentPage = newVal.currentPage || newVal.pageIndex;
					this.pageparm.pageSize = newVal.pageSize;
				}
			},
			deep: true
		}
	},
	methods: {
		handleSizeChange(val) {
			/**
			 * 子传父
			 * 参数1 父元素方法
			 * 参数2 数据
			 */
			this.pageparm.pageSize = val;
			const payload = {
				currentPage: this.pageparm.currentPage || this.pageparm.pageIndex,
				pageSize: this.pageparm.pageSize
			};
			// Vue2 事件名区分大小写：同时派发 kebab 与 camel，兼容所有父级监听写法
			this.$emit("call-father", payload);
			this.$emit("callFather", payload);
		},
		handleCurrentChange(val) {
			/**
			 * 子传父
			 * 参数1 父元素方法
			 * 参数2 数据
			 */
			this.pageparm.currentPage = val;
			this.pageparm.pageIndex = val;
			const payload = {
				currentPage: val,
				pageSize: this.pageparm.pageSize
			};
			this.$emit("call-father", payload);
			this.$emit("callFather", payload);
		}
	}
};
</script>

<style>
.page-box {
	display: flex;
	justify-content: flex-end;
	margin-top: 0;
	padding: 12px 0 4px;
	background: var(--app-surface);
}
</style>
